import { render, staticRenderFns } from "./EditBot.vue?vue&type=template&id=2d341c2e&scoped=true"
import script from "./EditBot.vue?vue&type=script&lang=js"
export * from "./EditBot.vue?vue&type=script&lang=js"
import style0 from "./EditBot.vue?vue&type=style&index=0&id=2d341c2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d341c2e",
  null
  
)

export default component.exports